export default __webpack_public_path__ + "static/tv-show-5-97ba7ba30b38d70ed6817f546e28c3f7.jpg";